import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconCircleTime = createIcon({
  path: (
    <>
      <path
        d="M12 23.1426C18.1541 23.1426 23.1429 18.1538 23.1429 11.9998C23.1429 5.84576 18.1541 0.856934 12 0.856934C5.846 0.856934 0.857178 5.84576 0.857178 11.9998C0.857178 18.1538 5.846 23.1426 12 23.1426Z"
        stroke="#CFDAEC"
        strokeWidth="1.5"
      />
      <path
        d="M11.9942 6.28613C8.83993 6.28613 6.28564 8.84613 6.28564 12.0004C6.28564 15.1547 8.83993 17.7147 11.9942 17.7147C15.1542 17.7147 17.7142 15.1547 17.7142 12.0004C17.7142 8.84613 15.1542 6.28613 11.9942 6.28613Z"
        fill="#3D6CB4"
      />
      <path
        d="M12 16.5716C9.4743 16.5716 7.42859 14.5259 7.42859 12.0001C7.42859 9.47443 9.4743 7.42871 12 7.42871C14.5257 7.42871 16.5714 9.47443 16.5714 12.0001C16.5714 14.5259 14.5257 16.5716 12 16.5716Z"
        fill="#E6ECF5"
      />
      <path
        d="M11.84 9.14307C11.6114 9.14307 11.4286 9.32592 11.4286 9.5545V12.2516C11.4286 12.4516 11.5314 12.6402 11.7086 12.7431L14.08 14.1659C14.2743 14.2802 14.5257 14.2231 14.64 14.0288C14.76 13.8345 14.6972 13.5774 14.4972 13.4631L12.2857 12.1488V9.5545C12.2857 9.32592 12.1029 9.14307 11.8743 9.14307H11.84Z"
        fill="#3D6CB4"
      />
    </>
  ),
});

export default IconCircleTime;
